import { clsx, makeKey, styx } from "modules/Utils";
import ImagePalette from "./ImagePalette";
import { CSSProperties } from "react";
import Colors from "modules/Colors";
import useWebsiteBuilder, { WebsiteBuilderContentType } from "Hooks/useWebsiteBuilder";
import ColorPickerInput from "./ColorPickerInput";
import ButtonSymphony from "./ButtonSymphony";

interface MultiPaletteProps {
    className?: string;
    style?: CSSProperties;
    selectedColor: string;
    selectColor: (color: string) => void;
    showBlackAndWhite?: boolean;
    size?: number;
}

const MultiPalette = ({
    className,
    style,
    selectedColor,
    selectColor,
    showBlackAndWhite = true,
    size = 46,
}: MultiPaletteProps) => {
    const {
        websiteContent,
    } = useWebsiteBuilder();

    /** Get unique image URLs from website content to prevent duplicate color palettes */
    const uniqueImageContents = websiteContent.reduce((acc, content) => {
        const contentType = content.type;
        const contentHasImage = contentType === WebsiteBuilderContentType.IMAGE ||
            contentType === WebsiteBuilderContentType.MUSIC ||
            contentType === WebsiteBuilderContentType.VIDEO;

        if (!contentHasImage) {
            return acc;
        }

        const imageUrl = content.imageContent?.image ||
            content.musicContent?.selectedMusic?.thumbnail_url ||
            content.videoContent?.thumbnail;

        if (imageUrl && !acc.some(item => item.imageUrl === imageUrl)) {
            acc.push({
                content,
                imageUrl,
                index: acc.length,
            });
        }

        return acc;
    }, [] as Array<{ content: any; imageUrl: string; index: number }>);

    return (
        <>
            <div
                className={clsx("multiPaletteColorPickerContainer", className)}
                style={styx(
                    sty.multiPaletteColorPickerContainer,
                    style
                )}
            >
                <ColorPickerInput
                    className="websiteBuilderColorPickerModalColorPickerInput"
                    selectedColor={selectedColor}
                    selectColor={selectColor}
                />
                {/* <ButtonSymphony
                    className="websiteBuilderColorPickerModalButton"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                    }}
                    onClick={() => {
                        selectColor('');
                    }}
                    variant="text"
                >
                    Reset Color
                </ButtonSymphony> */}
                <ImagePalette
                    className="multiPaletteImagePalette2"
                    imageUrl={''}
                    selectedColor={selectedColor}
                    selectColor={selectColor}
                    showBlackAndWhiteOnly
                    showBlackAndWhite
                    size={size}
                    styleColorPaletteContainer={{
                        gap: 0
                    }}
                />
            </div>
            {/* <ImagePalette
                imageUrl={''}
                selectedColor={selectedColor}
                selectColor={selectColor}
                showBlackAndWhite
            /> */}
            {uniqueImageContents.map(({ content, imageUrl, index }) => (
                <div
                    key={makeKey(content.type, index)}
                    className="websiteBuilderColorPickerModalContentContainer"
                    style={sty.websiteBuilderColorPickerModalContentContainer}
                >
                    <img
                        className="multiPaletteImageWebsiteImage"
                        src={imageUrl}
                        style={{
                            width: 38,
                            height: 38,
                            objectFit: 'cover',
                            borderRadius: 8,
                        }}
                    />
                    <div
                        className="multiPaletteImagePaletteDivider"
                        style={{
                            height: 40,
                            width: 1,
                            backgroundColor: Colors.grey,
                            marginRight: -4,
                        }}
                    />
                    <ImagePalette
                        className="multiPaletteImagePalette1"
                        imageUrl={imageUrl}
                        selectedColor={selectedColor}
                        selectColor={selectColor}
                        showBlackAndWhite={showBlackAndWhite}
                        size={size}
                        styleColorPaletteContainer={{
                            gap: 0
                        }}
                    />
                </div>
            ))}
        </>
    )
}

const sty: Record<string, CSSProperties> = {
    websiteBuilderColorPickerModalContentContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    colorPickerBox: {
        background: "transparent",
        height: 32,
        width: 32,
        marginRight: 8,
        cursor: "pointer",
        borderRadius: 8,
    },

    multiPaletteColorPickerContainer: {
        width: '100%',
        display: 'flex',
        gap: 16,
    },
}

export default MultiPalette;